import withAdUnitPath from "../withAdUnitPath";
import Advert from "../../components/Advert";
import { getFloor } from "../../state/modules/config/selectors";

export default withAdUnitPath(Advert, {
  pageType: "SEARCH",
  floorSelector: getFloor
});
